<template>
  <div class="c-record-kpi">
    <!-- filter -->
    <ios-recharge-filter
      :medias="dropMedias"
      :game-data="gameData"
      @on-import="importExcel"
      @on-set="addRecord"
      @on-change="filterData"
      @on-search="searchFilterData"
    />
    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight" v-loading="loading">
        <ios-recharge-table
          :height="tableHeight"
          :data="tableList"
          :columns="tableCol"
          @on-edit="addRecord"
          @on-del="delRecord"
          @on-refresh="getData"
        />
        <el-pagination
          :total="total"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          :page-sizes="[10, 20, 30, 40, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="changePageIndex"
          @size-change="changePageSize"
          class="c-table-page pager"
          background
        />
      </Viewport>
    </div>
    <!-- 弹出框 -->
    <set-recharge
      v-model="model"
      title="自然量充值比"
      :game-data="gameData"
      :people-data="peopleData"
      :loading="loading"
      :medias="dropMedias"
      :edit="edit"
      :info="info"
      @on-save="saveRecord"
    />
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/ios_recharge_column'
import { setLocal, getLocal } from '@/common/js/api'
import { formatDate, isArray, isEmpty } from '@/common/js/utils'
import { HOST_API } from '@/api/config'
import { getSysMedia, getCaoHuaGames, getSysMember } from '@/api/common.model'
import { getIosRecharge, delIosRecharge, getIosRechargeList, importKpiExcel, setIosRecharge } from '@/api/manage.model'
import IosRechargeFilter from './components/ios-recharge-filter'
import IosRechargeTable from './components/ios-recharge-table'
import SetRecharge from './components/set-recharge'

export default {
  name: 'iosRecharge',
  mixins: [mixin],
  components: { IosRechargeFilter, IosRechargeTable, SetRecharge },
  methods: {
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      // 加载状态
      this.loading = true
      getIosRechargeList(params)
        .then((data) => {
          this.loading = false
          if (data) {
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.total = total_number || 0
              this.tableList = list.map((ret) => {
                return ret
              })
            }
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    setLocalPage(size) {
      setLocal('RECORD_KPI_PAGESIZE', size)
    },
    addRecord(edit) {
      this.edit = !!edit
      if (edit) {
        const { tdateMonth, gameId } = edit
        this.loading = true
        getIosRecharge({
          tdateMonth,
          gameId
        })
          .then((data) => {
            this.loading = false
            if (data) {
              const { gameId, tdateMonth, launchOps, thirtyMoney, platform } = data
              this.info = {
                platform,
                gameId,
                tdateMonth,
                launchOps,
                thirtyMoney
              }
              this.model = true
            }
          })
          .catch((err) => {
            this.$Message.error({
              duration: 5,
              content: err
            })
          })
      } else {
        this.info = Object.assign(this.info, {
          platform: '',
          gameId: '',
          tdateMonth: '',
          thirtyMoney: '',
          launchOps: []
        })
        this.model = true
      }
    },
    saveRecord(params) {
      params.tdateMonth = formatDate(new Date(params.tdateMonth), 'yyyy-MM')
      const { tdateMonth, gameId, launchOps, thirtyMoneyNum, platform } = params
      // const { gameId, month, mediaId, collect } = params
      // const fixedCollect = parseFloat(collect) > 0 ? div(collect, 100) : 0
      const { err, msg } = this.vaild({ thirtyMoneyNum, gameId, tdateMonth, launchOps })
      if (err) {
        this.$Message.error({
          duration: 5,
          content: msg
        })
        return
      }
      // tdateMonth : formatDate(new Date(tdateMonth), 'yyyy-MM')
      this.loading = true
      setIosRecharge({
        platform,
        thirtyMoney: thirtyMoneyNum,
        tdateMonth,
        gameId,
        launchOps,
        opType: this.edit ? 'modify' : ''
      }).then((data) => {
        this.loading = false
        if (data) {
          !this.edit && (this.pageIndex = 1)
          this.getData()
          this.model = false
        }
      })
    },
    delRecord(row) {
      const { tdateMonth, gameId } = row
      delIosRecharge({
        tdateMonth,
        gameId
      }).then((data) => {
        if (data) {
          this.getData()
        }
      })
    },
    vaild(params) {
      const keys = Object.keys(params)
      const value = { thirtyMoneyNum: '30日充值金额', gameId: '游戏', tdateMonth: '月份', opId: '人员', mediaId: '媒体', ratio: '比例' }
      let err = false
      let msg = ''

      keys.some((ret) => {
        if (ret === 'launchOps') {
          if (isArray(params.launchOps) && params.launchOps.length) {
            params.launchOps.some((ret) => {
              const subKeys = Object.keys(ret)
              subKeys.some((key) => {
                if (!ret[key]) {
                  msg = `${value[key]}不能为空`
                  err = true
                  return true
                }
              })
            })
            // 人员和媒体的查重
            params.launchOps.forEach((el, index) => {
              if (
                el.opId &&
                el.mediaId &&
                index !== params.launchOps.findIndex((ret) => ret.opId === el.opId && ret.mediaId === el.mediaId)
              ) {
                const dulPeople = this.peopleData.filter((ret) => ret.id === el.opId)[0].name
                const dulMedia = this.dropMedias.filter((ret) => ret.id === el.mediaId)[0].name
                msg = `${dulPeople}人员和${dulMedia}媒体不可重复选择`
                err = true
              }
            })
          } else {
            msg = '至少添加一条人员信息'
            err = true
          }
        } else if (isEmpty(params[ret])) {
          msg = `${value[ret]}不能为空`
          err = true
          // return false
        }
      })
      return { err, msg }
    },
    downExcel() {
      window.open(`${HOST_API}/api/ptom/template/downTemplate?templateType=template_guangz_kpi`, '_blank')
    },
    downFailExecl(req) {
      window.open(`${HOST_API}/api/ptom/guangzKpiSet/downloadImportResult?requestId=${req}`)
    },
    importExcel(file) {
      this.$Spin.show()
      importKpiExcel({ file }).then((data) => {
        this.$Spin.hide()
        if (data) {
          this.resultModel = true
          this.added = data.addTotal
          this.failure = data.failTotal
          this.updated = data.updateTotal
          this.req_id = data.requestId
        }
      })
    },
    preLoadData() {
      Promise.all([getSysMedia(), getCaoHuaGames(), getSysMember()])
        .then((data) => {
          const [mediaData, gameData, peopleData] = data
          if (isArray(mediaData)) {
            this.dropMedias = mediaData.map((ret) => {
              return {
                id: ret.mediaId,
                name: ret.mediaName
              }
            })
          }
          isArray(gameData) && (this.gameData = gameData)
          isArray(peopleData) && (this.peopleData = peopleData)
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    }
  },
  data() {
    return {
      tableHeight: 330,
      model: null,
      loading: null,
      info: {},
      edit: null,
      gameData: [],
      peopleData: [],
      resultModel: null,
      added: 0,
      failure: 0,
      updated: 0,
      req_id: '',

      dropMedias: []
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('RECORD_KPI_PAGESIZE')) || 20
    this.tableCol = columns
    this.preLoadData()
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
